import "./floating-cards.css";

const coreCards = [
  {
    type: "placement",
    name: "Taruun Prasath GS",
    company: "Ajira  CASA Retail",
    package: "₹7 LPA",
    content:
      "The training provided by Better Tomorrow played a crucial role in my interview success by strengthening my technical skills and problem-solving abilities.",
  },
  {
    type: "placement",
    name: "Ashwithaa L",
    company: "Codemagen",
    package: "₹6 LPA",
    content:
      "The Better Tomorrow training played an important part in my interview preparation and success.Hepls in strength my skills and problem-solving abilities.",
  },
  {
    type: "placement",
    name: "Aswin MA",
    company: "Presidio",
    package: "₹10 LPA",
    content:
      "I'm excited to share that I got selected by Presidio with a 10 LPA offer during my pre-final year! Thanks to Better Tomorrow for their amazing training.",
  },
];

// Problem-solving focused cards for the second row
const problemSolvingCards = [
  {
    // First circle card
    content: "Problem solving",
    shape: "circle-1",
  },
  {
    // Second circle card
    content: "Data Structures & Algorithms", 
    shape: "circle-2",
  },
  {
    // Rectangle card
    content: "Full stack development",
    shape: "pill",
  }
];

// Repeat the cards to fill the marquee; adjust repeatCount for density
const repeatCount = 2;
const repeatedTopCards = Array.from({ length: repeatCount }).flatMap(() => coreCards);
const repeatedBottomCards = Array.from({ length: repeatCount }).flatMap(() => problemSolvingCards);

const cardRows = [
  { cards: repeatedTopCards, speed: "slow", reverse: false },
  { cards: repeatedBottomCards, speed: "medium", reverse: false, isSmall: true },
];


export default function FloatingCards() {
  const glowClasses = ["glow-yellow", "glow-red", "glow-green"];
  const pickGlow = (rowIdx, idx) => glowClasses[(rowIdx + idx) % glowClasses.length];
  
  // Card renderer function that handles missing fields gracefully
  const renderCard = (card, i, idx, offset = 0) => {
    // If card is a string, render it as-is
    if (typeof card === "string") {
      return (
        <div className={`card card--glow ${pickGlow(i, idx + offset)}`} key={`r${i}-${offset ? 'b' : 'a'}-${idx}`}>
          {card}
        </div>
      );
    }
    
    // For object cards, always ensure a consistent structure
    // Special styling for second row (i === 1)
    const isSecondRow = i === 1;
    
    // Get the shape class if specified
    const shapeClass = card.shape ? `card--${card.shape}` : '';
    
    return (
      <div className={`card card--placement card--glow ${pickGlow(i, idx + offset)} ${isSecondRow ? 'card--topic card--small' : ''} ${shapeClass}`} key={`r${i}-${offset ? 'b' : 'a'}-${idx}`}>
        {/* Different layout for second row vs first row */}
        {isSecondRow ? (
          <div className="card-content-centered">
            <div className="card-topic">
              {card.content || "Better Tomorrow helped me develop valuable skills for my career."}
            </div>
          </div>
        ) : (
          <div className="card-horizontal-layout">
            {/* Left side - Content */}
            <div className="card-left-content">
              <div className="card-content">
                <div className="quote-mark">&ldquo;</div>
                <div className="card-line card-desc">
                  {card.content || "Better Tomorrow helped me develop valuable skills for my career."}
                </div>
                <div className="quote-mark end-quote">&rdquo;</div>
              </div>
            </div>
            
            {/* Right side - Package, Name, Company */}
            <div className="card-right-info">
              {/* Package highlighted at top */}
              {card.package && (
                <div className="card-package-highlight">
                  {card.package}
                </div>
              )}
              
              {/* Name and Company below */}
              <div className="card-personal-info">
                {card.name && (
                  <div className="card-name-horizontal">{card.name}</div>
                )}
                {card.company && (
                  <div className="card-company-horizontal">{card.company}</div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  return (
    <div className="board">
      {cardRows.map((row, i) => (
        <div key={`row-${i}`}>
          <div className={`row ${row.speed}${row.reverse ? " reverse" : ""}${row.isSmall ? " row--small" : ""}`}>
            <div>
              <div className="marquee">
                <div className="cards">
                  {row.cards.map((card, idx) => renderCard(card, i, idx))}
                </div>
                <div className="cards">
                  {row.cards.map((card, idx) => renderCard(card, i, idx, 100))}
                </div>
              </div>
            </div>
          </div>
          
          {/* Add typing effect in the gap between first and second row */}
          {/* {i === 0 && (
            <div className="testimonial-gap">
              <HackerTypeOverlay text="Testimonial" />
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
}